import React, { useState } from "react";

const API_BASE = process.env.REACT_APP_API_BASE;
const MAX_FILE_SIZE_MB = 10;

function H5ADUploader({ onUploadSuccess }) {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];

    setMessage("");
    setError("");

    if (selectedFile) {
      const fileSizeMB = selectedFile.size / (1024 * 1024); // bytes to MB
      if (fileSizeMB > MAX_FILE_SIZE_MB) {
        setFile(null);
        setError(`❌ File too large. Max ${MAX_FILE_SIZE_MB}MB allowed.`);
        console.warn(`🚫 File rejected: ${fileSizeMB.toFixed(2)}MB`);
        return;
      }

      setFile(selectedFile);
      console.log("📁 Selected file:", selectedFile.name, `(${fileSizeMB.toFixed(2)}MB)`);
    }
  };


  const handleUpload = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    setMessage("⏳ Uploading...");
    setError("");
    try {
      console.log("📡 API base:", API_BASE);
      const uploadRes = await fetch(`${API_BASE}/upload/`, {
        method: "POST",
        body: formData,
      });
      const uploadData = await uploadRes.json();

      if (!uploadRes.ok) throw new Error(uploadData.error || "Upload failed.");

      const { handle } = uploadData;
      console.log("🆔 Handle:", handle);
      onUploadSuccess(handle);
      setMessage("✅ Upload complete.");
    } catch (err) {
      console.error(err);
      setError(err.message);
      setMessage("");
    }
  };

  return (
    <div className="bg-white p-4 rounded shadow-md">
      <input type="file" accept=".h5ad" onChange={handleFileChange} />
      <button
        onClick={handleUpload}
        className="mt-2 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
      >
        Upload
      </button>

      {message && <p className="text-green-600 mt-4">{message}</p>}
      {error && <p className="text-red-600 mt-4">{error}</p>}
    </div>
  );
}

export default H5ADUploader;